import { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { NAV, COMPANY } from "@/lib/constants";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Top utility bar removed per request */}

      <header
        className={`sticky top-0 z-40 transition-all duration-300 ${
          scrolled ? "bg-white/95 backdrop-blur shadow-[0_4px_24px_-12px_rgba(14,42,92,0.25)]" : "bg-white"
        }`}
        data-testid="main-navbar"
      >
        <div className="container-x flex items-center justify-between py-3">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
            <img src={COMPANY.logoMark} alt="ISGS Asbestos Consulting" className="h-11 w-11 object-contain" />
            <div className="hidden sm:block leading-tight">
              <div className="text-[#0E2A5C] font-bold tracking-tight text-[18px]">ISGS</div>
              <div className="text-[#5B6478] text-[11px] uppercase tracking-[0.18em]">Asbestos Consulting</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `text-[14.5px] font-medium link-anim transition-colors ${
                    isActive ? "text-[#0E2A5C]" : "text-[#0B0F1A]/75 hover:text-[#0E2A5C]"
                  }`
                }
                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={`tel:${COMPANY.phoneAltTel}`}
              className="btn-primary !py-2.5 !px-5 text-sm hidden sm:inline-flex"
              data-testid="nav-call-button"
            >
              <Phone size={16} /> 1800 47 48 49
            </a>
            <button
              className="lg:hidden p-2 text-[#0E2A5C]"
              onClick={() => setOpen(!open)}
              aria-label="Toggle menu"
              data-testid="mobile-menu-toggle"
            >
              {open ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden border-t border-[#0E2A5C]/10 bg-white" data-testid="mobile-nav-panel">
            <nav className="container-x py-4 flex flex-col gap-1">
              {NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `py-3 px-3 rounded-lg text-[15px] font-medium transition-colors ${
                      isActive ? "bg-[#0E2A5C] text-white" : "text-[#0B0F1A] hover:bg-[#A6CD3C]/15"
                    }`
                  }
                  data-testid={`mobile-nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        )}
      </header>
    </>
  );
}
